import mirrorCreator from 'mirror-creator';
import Immutable from 'immutable';
import { createSelector } from 'reselect';
import pipe from 'helpers/redux-state-mutators.js';
import queryString from 'query-string';
import config from 'config/api';

const actionTypes = mirrorCreator(['SET_REPLAY_DATA', 'SET_REPLAY_ERROR', 'CLEAR_REPLAY'], { prefix: 'event/' });

const mutators = {
  setReplayData: (event) => ($$state) => $$state.set('event', event),
  setReplayError: (error) => ($$state) => $$state.set('error', error),
};

export default function reducer($$state = Immutable.Map(), action) {
  let acts = [];
  switch (action.type) {
    case actionTypes.SET_REPLAY_DATA:
      acts.push(mutators.setReplayData(action.event));
      // if (action.state === true) acts.push(mutators.clearErrors);
      return pipe(acts, $$state);

    case actionTypes.SET_REPLAY_ERROR:
      return pipe([mutators.setReplayError(action.error)], $$state);

    case actionTypes.CLEAR_REPLAY:
      return pipe([mutators.setReplayError(undefined), mutators.setReplayData(undefined)], $$state);

    default:
      return $$state;
  }
}

export const getRoot = (state) => state.replay || Immutable.Map();
export const getReplayData = createSelector([getRoot], ($$state) => $$state.get('event'));
export const getReplayError = createSelector([getRoot], ($$state) => $$state.get('error'));

export function fetchReplay({ replayId, params }) {
  return (dispatch) => {
    let url = config.events + '/replay/' + replayId;

    if (params.k !== undefined && params.r === undefined) url = url+'?k='+params.k;
    if (params.r !== undefined && params.k === undefined) url = url+'?r='+params.r;
    if (params.r !== undefined && params.k !== undefined) url = url+'?k='+params.k+'&r='+params.r;
    let formData = {};
    formData.contact_form = true;

    fetch(url, {
      credentials: 'include',
      method: config.urlMethod || 'post',
      headers: {
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest', // needed by php api
      },
      body: queryString.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.replay && response.replay === 'complete') {
          dispatch(setReplayData(Immutable.fromJS(response.data)));
        } else {
          dispatch(setReplayError(response.log));
        }
      })
      .catch((error) => dispatch(setReplayError(error.message)));
  };
}
export function setReplayData(event) {
  return {
    type: actionTypes.SET_REPLAY_DATA,
    event,
  };
}
export function setReplayError(error) {
  return {
    type: actionTypes.SET_REPLAY_ERROR,
    error,
  };
}
export function clearReplay() {
  return {
    type: actionTypes.CLEAR_REPLAY,
  };
}



// WEBPACK FOOTER //
// ./src/components/UI/Replays/ducks/replay.js